import React, { CSSProperties, useState } from 'react'
import { ReactComponent as PlusIcon } from '@svgs/illustration/plus.svg'
import classnames from 'classnames'
import styles from './styles.module.scss'

type Image = {
  file: {
    url: string
  }
}

type Item = {
  title: string
  description: string
  imageMobileHero: Image
  imageDesktopHero: Image
}

type SizingItemProps = {
  item: Item
  active?: boolean
  mobile?: boolean
  onClick?: () => void
}

function SizingItem({
  item,
  mobile = false,
  onClick,
  active = false
}: SizingItemProps) {
  const [onHover, setOnHover] = useState(false)
  const { title, description, imageMobileHero, imageDesktopHero } = item
  const toggleHover = () => setOnHover(!onHover)

  const customClasses = classnames(styles.sizingItemHero, {
    [styles.sizingItemHero_mobileActive]: active,
    [styles.sizingItemHero_mobile]: mobile
  })

  const styleObjForDesktop = {
    '--sizing-item-hero-image': `url(${imageDesktopHero.file.url})`
  } as CSSProperties

  const styleObjForMobile = {
    backgroundImage: `url(${imageMobileHero.file.url})`
  }

  if (mobile) {
    return (
      <div
        className={customClasses}
        style={styleObjForMobile}
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyUp={onClick}
      >
        <div className={styles.sizingItemHero__content}>
          <h3 className={styles.sizingItemHero__title}>{title}</h3>
          <p className={styles.sizingItemHero__description}>{description}</p>
          <div className={styles.sizingItemHero__mobileIcon}>
            <PlusIcon />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={`sizing-item-hero ${styles.sizingItemHero}`}
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
      style={styleObjForDesktop}
    >
      <div
        className={`sizing-item-hero__content ${styles.sizingItemHero__content}`}
      >
        <h3 className={styles.sizingItemHero__title}>{title}</h3>
        <p className={styles.sizingItemHero__description}>{description}</p>
      </div>
    </div>
  )
}

export default SizingItem
